<template class="modal-redeem-platelist">
<b-modal id="redeem-platelist-modal" centered :hide-footer="true" :hide-header="true" size="sm">
  <template v-slot:default="{ hide }">
    <p class="modal-title">Unlock Platelist</p>
  </template>

  <div class="modal-text">
    <p>Enter your code to redeem this Platelist.</p>
    <BaseInput :class="[{ error: this.error }]" v-model="unlockCode" placeholder="Enter code" />
    <p class="errorMsg" v-if="this.error">{{ this.error }}</p>

    <BaseButton class="btn-submit" :disabled="submitting" @click="submit">
      <BaseIcon v-if="submitting" name="sync" spin />
      <span v-if="submitting">Submitting...</span>
      <span v-else>Submit</span>
    </BaseButton>
  </div>

  <template v-slot:modal-footer="{ hide }">
    <BaseButton class="btn-clear" @click="hide()">
      Close
    </BaseButton>
  </template>
</b-modal>
</template>

<script>
import { platelistComputed, platelistMethods } from '@state/helpers';

export default {
  components: {},
  data() {
    return {
      error: '',
      submitting: false,
      unlockCode: '',
    };
  },
  props: {},
  computed: {
    ...platelistComputed,
  },
  methods: {
    ...platelistMethods,
    hide() {
      this.$bvModal.hide('redeem-platelist-modal');
      this.submitting = false;
      this.error = '';
      this.unlockCode = '';
    },
    async submit() {
      const passCodeRegex = this.selectedPlatelist.contentLockStatus.passCodeRegex;
      const regex = RegExp(passCodeRegex);

      if (!regex.test(this.unlockCode)) {
        this.error = 'Invalid code';
      } else {
        this.submitting = true;
        this.error = '';
        this.unlockPlatelist(this.selectedPlatelist.id).then(async (res) => {
          await this.setUpdatePlatelistLockStatus(res);
          this.hide();
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import 'theme.scss';

.modal-title {
  font-size: 1.7rem;
  font-weight: 600 !important;
  margin-bottom: 2.4rem;
}

.modal-body {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.modal-text {
  font-weight: 400;
  margin-bottom: 0;
  text-align: center;

  input {
    line-height: 2;
    margin: 2rem auto 2.5rem auto;
    max-width: 37.5rem;

    &::placeholder {
      color: $color-text;
      line-height: 2;
      opacity: 0.5;
    }

    &.error {
      border-color: $color-error;
      border-width: 0.2rem;
      margin-bottom: 1rem;
    }
  }

  .errorMsg {
    color: $color-error;
    font-size: 1.4rem;
    font-weight: 400;
    margin: 0 auto 2rem auto;
    max-width: 37.5rem;
    text-align: left;
  }

  .btn-submit {
    // background-color: $color-button-text;
    // color: $color-action;
    // padding: 1rem 2rem;

    // background-color: $color-action;
    // border-color: $color-action;
    // border-radius: $base-border-radius;
    // font-size: 1.7rem;

    background-color: $color-action;
    border-radius: $size-plan-detail-apply-btn-border-radius;
    bottom: 3rem;
    color: $color-plan-detail-cta-button-text;
    padding: 1rem 1.5rem;
    width: 16rem;

    .fa-sync {
      margin-right: 1rem;
    }
  }
}
</style>
